import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { EARNED_MEDIA_BY_ACCOUNT } from "../keys";

/**
 * Hook to fetch earned media metrics (engagement/exposures) grouped by account
 * that tagged or mentioned the tenant's social accounts.
 *
 * Expected API response format:
 * {
 *   graphs: [
 *     {
 *       source: "Weekly" | "Monthly" | "Total",
 *       data: {
 *         labels: ["Jan", "Feb", ...],
 *         series: [
 *           { name: "@account1", data: [100, 200, ...], color: "#..." },
 *           { name: "@account2", data: [50, 75, ...], color: "#..." },
 *         ],
 *         xTitle: "Period",
 *         yTitle: "Engagement"
 *       }
 *     },
 *     ...
 *   ]
 * }
 */
const useEarnedMediaByAccount = () => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [EARNED_MEDIA_BY_ACCOUNT, tenant.id, startDate, endDate],
    queryFn: () => ApiService.getEarnedMediaByAccount(since, until),
    select: (data) => data.data.graphs,
    placeholderData: { data: { graphs: [] } },
    enabled,
  });
};

export default useEarnedMediaByAccount;
